/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title37 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P37 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        {/* <div  className={s.wrapper}> */}
          <Title37 pageNumber="4.1">各话题方向对索尼数字品牌价值贡献度分析
          </Title37>

          <div className={s.content}>
            <div>
              <div contentEditable className={s.subTitle}>
                产品品牌的产品/市场推广/份额贡献度最高，达74.69%；领导人品牌的数字品牌价值为负值
              </div>
              <div contentEditable className={s.des}>
                产品品牌的产品/市场推广/份额话题最为火爆，其DB值达到<span className={s.emphasis}>610,775,895<i>DB</i></span>，贡献度为<span className={s.emphasis}>74.69%</span>，较上半财年（<span className={s.emphasis}>70.26%</span>）有所提升。公司品牌中，品牌方向的DB值最高，为<span className={s.emphasis}>131,610,331<i>DB</i></span>，占比为<span className={s.emphasis}>16.09%</span>（高于上半财年<span className={s.emphasis}>6.99%</span>）；其它依次为：研发/专利、收购/合作、ESG、业绩/战略、企业运营。领导人品牌的DB值为<span className={s.emphasis}>-27,403,495<i>DB</i></span>，贡献度为<span className={s.emphasis}>-3.35%</span>，主要是因为索尼本田社长川西泉公开质疑中国电动车，影响大。
              </div>
              <div contentEditable className={s.unitText_1}>各话题方向对索尼整体数字品牌价值贡献度图
              </div>
              <div contentEditable className={s.unitText_2}>来源：数字品牌榜</div>
              <div contentEditable className={s.unitText_2}>时间范围：2023.10.01-2024.03.31
              </div>
            </div>

            <div className={s.uiWrapper}>
              
              <div className={s.chartWrapper}>
                <TooltipDrawer
                    style={{ width: '100%', height: '100%' }}
                    formContent={<Form onChange={values => this.setState({ ...values })} />}>
                    <Chart options={setChart({
                      label: chartTitle,
                      list: chartList,
                      color: chartColorList
                    })} />
                  </TooltipDrawer>
              </div>
              
            </div>
            <div className={s.labelBox} contentEditable>
                <div style={{color: '#ffd70d'}}>领导人品牌</div>
                <div style={{color: '#2094ce'}}>公司品牌</div>
                <div style={{color: '#eb5f74'}}>产品品牌</div>
              </div>
          </div>
          <div className={s.explain}>
            *数据说明：各话题方向对索尼整体数字品牌价值的贡献度之和并不是100%，原因是许多内容会提及索尼的多个方面，会同时归入不同话题方向进行计算。
          </div>
        {/* </div> */}
    
      </Stage>
    );
  }
}

export default withStyles(s)(P37);



// WEBPACK FOOTER //
// src/routes/visualChart/P37/index.js